module.exports = __webpack_public_path__ + "img/tr.0e41e1b9.svg";